"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NutritionWeek = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const styled_components_1 = __importDefault(require("styled-components"));
const DayPreview_1 = require("./DayPreview");
const NutritionFacts_1 = require("./NutritionFacts");
const CalorieBudgetNutritionWeekItem_1 = require("./CalorieBudgetNutritionWeekItem");
const changeOrderInNutritionFacts_1 = require("../nutrition-day/changeOrderInNutritionFacts");
const renderNutritionDays = (nutritionWeekItemsData, calorieBudgetBundle, noBudget) => {
    return nutritionWeekItemsData.map((item) => {
        return ((0, jsx_runtime_1.jsx)(DayPreview_1.DayPreview, { translations: item.translations, day: item.day, unit: item.unit, onClick: item.onClick, calorieBudgetBundle: calorieBudgetBundle, noCalorieBudget: noBudget }, item.day.date));
    });
};
const NutritionWeek = (props) => {
    const listItems = [];
    if (props.isCalorieTracked) {
        listItems.push((0, jsx_runtime_1.jsx)(NutritionFacts_1.NutritionFacts, { translations: (0, changeOrderInNutritionFacts_1.changeOrderInFactsTranslations)(props.nutritionWeekItemsData[0].translations) }, "facts"));
        if (!props.calorieBudgetData.noCalorieBudget) {
            listItems.push((0, jsx_runtime_1.jsx)(CalorieBudgetNutritionWeekItem_1.CalorieBudgetNutritionWeekItem, { isTrainingDay: true, translations: props.calorieBudgetData.translations, calorieBudget: props.calorieBudgetData.budget.forTrainingDay, unit: props.nutritionWeekItemsData[0].unit || "" }, "summaryTrainingDay"), (0, jsx_runtime_1.jsx)(CalorieBudgetNutritionWeekItem_1.CalorieBudgetNutritionWeekItem, { translations: props.calorieBudgetData.translations, calorieBudget: props.calorieBudgetData.budget.forNonTrainingDay, unit: props.nutritionWeekItemsData[0].unit || "" }, "summaryNonTrainingDay"));
        }
    }
    listItems.push(...renderNutritionDays(props.nutritionWeekItemsData, props.calorieBudgetData.budget, props.calorieBudgetData.noCalorieBudget));
    return (0, jsx_runtime_1.jsx)(List, { children: listItems }, void 0);
};
exports.NutritionWeek = NutritionWeek;
const List = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0;

    & > div:nth-of-type(3) {
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=NutritionWeek.js.map